import { filter, map } from 'rxjs';
import { Observable } from 'rxjs/internal/Observable';
import { IdValue } from '../models/id-value.model';

/**
 * Creates IdValue using index (starting at 0).
 * Intended for creating IdValues when a Clear 1 enum does NOT exist.
 * @param names The display names for the IdValue objects.
 * @param useStringValue Whether to have 'value' as a number or string.
 * @returns IdValue[] - uses default type <number, string, string>.
 */
export const mapToIdValues = (names: string[], useStringValue = true): IdValue[] =>
  names.map((name, index) => {
    let value;
    if (useStringValue) {
      value = index.toString();
    } else {
      value = index;
    }
    return new IdValue(index, value, name);
  });

/**
 * @param idValues
 * @returns Returns IdValues without an empty `name` value.
 */
export const removeEmptyNames = (idValues: Observable<IdValue<string, string, string>[]>) =>
  idValues.pipe(
    filter((idValues) => !!idValues),
    map((idValues) => idValues.filter((i) => !!i.name)),
  );

export const addSelectOption$ = (idValues: Observable<IdValue<string, string, string>[]>) =>
  idValues.pipe(map((idValues) => [new IdValue<string, string, string>(null, 'Select', 'Select'), ...idValues]));
